var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnatomy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "21-anatomy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 28h-7a1 1 0 0 0-.707.293L35.586 30H32a1 1 0 0 0-1 1v8.586L29.586 41h-4.172L22 37.586V36h-2v2a1 1 0 0 0 .293.707l4 4A1 1 0 0 0 25 43h5a1 1 0 0 0 .707-.293l.293-.293V62h2V32h3a1 1 0 0 0 .707-.293L38.414 30H46v-1a1 1 0 0 0-1-1zM51 34.414l1.707-1.707-1.414-1.414L50 32.586l-1.293-1.293-1.414 1.414L49 34.414v12.172l-1.707 1.707 1.414 1.414L50 48.414l1.293 1.293 1.414-1.414L51 46.586zM51.293 52.293 50 53.586l-1.293-1.293-1.414 1.414L49 55.414V62h2v-6.586l1.707-1.707z",
    fill: "#7f56d9",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.707 35.707 2-2-1.414-1.414L40.586 34H35v2h6a1 1 0 0 0 .707-.293zM35 40h6a1 1 0 0 0 .707-.293l1-1-1.414-1.414-.707.707H35zM35 44h5a1 1 0 0 0 .707-.293l1-1-1.414-1.414-.707.707H35zM35 48h5a1 1 0 0 0 .707-.293l1-1-1.414-1.414-.707.707H35zM35 52h3a1 1 0 0 0 .707-.293l1-1-1.414-1.414-.707.707H35zM42 53h-1a1 1 0 0 0-.707.293L37.586 56H35v2h3a1 1 0 0 0 .707-.293L41.414 55H42a1 1 0 0 1 1 1v4h-8v2h9a1 1 0 0 0 1-1v-5a3 3 0 0 0-3-3zM49 50h2v2h-2zM24 28a1 1 0 0 0 .707-.293l3-3A1 1 0 0 0 28 24v-2.81a1 1 0 0 0-.5-.867A5 5 0 0 1 25 16V9a5.006 5.006 0 0 1 5-5h1v24a1 1 0 0 0 1 1h3v-2h-2v-1h2v-2h-2v-1h1a7.008 7.008 0 0 0 7-7V9a7.008 7.008 0 0 0-7-7h-4a7.008 7.008 0 0 0-7 7v7a7.008 7.008 0 0 0 3 5.739v1.847L23.586 26H21a10.011 10.011 0 0 0-10 10v26h2V36a8.009 8.009 0 0 1 8-8zM39 9v7a5.006 5.006 0 0 1-5 5h-1v-2h2a1 1 0 0 0 1-1v-2h1a1 1 0 0 0 1-1v-1h-3a1 1 0 0 0-1 1v2h-1v-6h3V9h-3V4h1a5.006 5.006 0 0 1 5 5z",
    fill: "#7f56d9",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 41.586-2.293-2.293-1.414 1.414L19 42.414V62h2v-6l2 1.5V62h2v-5.5l-4-3zM48 9a1 1 0 0 0-.707.293l-5 5 1.414 1.414L48.414 11H62V9zM47.293 17.293l-8 8 1.414 1.414L48.414 19H62v-2H48a1 1 0 0 0-.707.293zM21.293 22.707l1.414-1.414-6-6A1 1 0 0 0 16 15H2v2h13.586z",
    fill: "#7f56d9",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.293 24.707 1.414-1.414-2-2A1 1 0 0 0 16 21H2v2h13.586zM2 7h19v2H2zM7 39H2v2h4.586l1.707 1.707 1.414-1.414-2-2A1 1 0 0 0 7 39zM53.293 25.293l-3 3 1.414 1.414L54.414 27H62v-2h-8a1 1 0 0 0-.707.293zM54.293 43.293l-2 2 1.414 1.414L55.414 45H62v-2h-7a1 1 0 0 0-.707.293zM53 58h9v2h-9zM2 58h7v2H2z",
    fill: "#7f56d9",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnatomy);
export default __webpack_public_path__ + "static/media/anatomy.15d2e8eeff6ef2e7791447e2abcc3df7.svg";
export { ForwardRef as ReactComponent };